import {svgIconWrapper} from '../svg-icon-wrapper';

import IntegrationOutlineRegular from './integration-outline-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <IntegrationOutlineRegular {...props} />;
}

SvgComponent.iconName = 'integrationOutlineRegular';

export const IntegrationOutlineRegularIcon = svgIconWrapper(SvgComponent);
